// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Printables_wrapper__A-1S6","printable-box":"Printables_printable-box__4xkE2","no-printables":"Printables_no-printables__1cYrM"};